import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getAllAresaCeter,
  getAllUserList,
  getAllUserRole,
  handleAddMember,
  handleUpdateMember, // Add this action for update
} from "../../redux/actions/grievanceActions1";
import md5 from "md5";

const AddMember = ({ onClose, show, userDetails = null, isEdit = false }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Member form state
  const [formData, setFormData] = useState({
    role_id: "",
    name: "",
    email: "",
    unit_centre_id: "",
    password: "12345",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [centerSearch, setCenterSearch] = useState("");
  const [showCenterDropdown, setShowCenterDropdown] = useState(false);

  const { userRoleMaster, getAllCenter } = useSelector(
    (state) => state.grievances
  );

  useEffect(() => {
    dispatch(getAllUserRole());
    dispatch(getAllAresaCeter());
  }, [dispatch]);

  // Populate form when editing
  useEffect(() => {
    if (isEdit && userDetails) {
      setFormData({
        role_id: userDetails.ROLE_ID || "",
        name: userDetails.USER_NAME || "",
        email: userDetails.EMAIL || "",
        unit_centre_id: userDetails.UNIT_CENTRE_ID || 0,
        // Keep default for edit mode
      });
    } else {
      // Reset form for add mode
      setFormData({
        role_id: "",
        name: "",
        email: "",
        unit_centre_id: "",
        password: "12345",
      });
    }
  }, [isEdit, userDetails, show]);

  // Handle input changes
  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
    // Clear error when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  // Email validation function
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Form validation
  const validateForm = () => {
    const newErrors = {};

    if (!formData.role_id) newErrors.role_id = "Role is required";

    if (!formData.name.trim()) newErrors.name = "Full Name is required";

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!isEdit) {
      if (!formData.password.trim()) {
        newErrors.password = "Password is required";
      } else if (formData.password.length < 5) {
        newErrors.password = "Password must be at least 5 characters long";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission (Add or Update)
  const handleSubmit = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      if (isEdit) {
        // Update member
        const updateData = {
          addInfo: {
            user_id: userDetails.USER_ID,
            role_id: formData.role_id,
            name: formData.name.trim(),
            email: formData.email.trim(),
            unit_centre_id: formData.unit_centre_id,
          },
        };

        const res = await dispatch(handleUpdateMember(updateData));
        if (res.rCode == 0) {
          alert(res.rMessage || "Member updated successfully!");
          resetForm();
          onClose();
          await dispatch(getAllUserList());
        } else {
          alert(res.rMessage || "Error updating member!");
        }
      } else {
        // Add new member
        const memberData = {
          addInfo: {
            role_id: formData.role_id,
            name: formData.name.trim(),
            email: formData.email.trim(),
            unit_centre_id: formData.unit_centre_id || 0,
            password: md5(formData.password),
          },
        };

        const res = await dispatch(handleAddMember(memberData));
        if (res.rCode == 0) {
          alert(res.rMessage || "Member added successfully!");
          resetForm();
          onClose();
          await dispatch(getAllUserList());
        } else {
          alert(res.rMessage || "Error adding member!");
          resetForm();
          onClose();
        }
      }
    } catch (error) {
      console.error(`Error ${isEdit ? "updating" : "creating"} member:`, error);
      alert(
        `Error ${isEdit ? "updating" : "creating"} member. Please try again.`
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Reset form
  const resetForm = () => {
    setFormData({
      role_id: "",
      name: "",
      email: "",
      unit_centre_id: "",
      password: "12345",
    });
    setErrors({});
    setCenterSearch("");
    setShowCenterDropdown(false);
    setShowPassword(false);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  // Filter centers based on search
  const filteredCenters = getAllCenter
    ? getAllCenter.filter((center) =>
        center.ADDRESS.toLowerCase().includes(centerSearch.toLowerCase())
      )
    : [];

  if (!show) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0, 0, 0, 0.5)" }}
      tabIndex={-1}
      role="dialog"
      aria-labelledby="AddEditMemberModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div style={{ backgroundColor: "#fff" }} className="modal-content">
          <div className="modal-header">
            <h5
              className="modal-title font-size-16"
              id="addEditMember-exampleModalLabel"
            >
              <i
                className={`bi ${
                  isEdit ? "bi-person-gear" : "bi-person-plus-fill"
                } me-2`}
              ></i>
              {isEdit ? "Edit Member" : "Add New Member"}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={handleClose}
            ></button>
          </div>

          <div className="modal-body p-4">
            <div className="row">
              {/* Role */}
              <div className="col-md-12 mb-3">
                <label htmlFor="role" className="form-label">
                  Role <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-control ${
                    errors.role_id ? "is-invalid" : ""
                  }`}
                  id="role"
                  value={formData.role_id}
                  onChange={(e) => handleInputChange("role_id", e.target.value)}
                >
                  <option value="">Select Role</option>
                  {userRoleMaster.map(
                    (role) =>
                      role.ROLE_ID != 1 &&
                      role.ROLE_ID != 4 && (
                        <option key={role.ROLE_ID} value={role.ROLE_ID}>
                          {role.ROLE_NAME}
                        </option>
                      )
                  )}
                </select>
                {errors.role_id && (
                  <div className="invalid-feedback">{errors.role_id}</div>
                )}
              </div>

              {/* Full Name */}
              <div className="col-md-12 mb-3">
                <label htmlFor="name" className="form-label">
                  Full Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.name ? "is-invalid" : ""}`}
                  id="name"
                  placeholder="Enter full name"
                  value={formData.name}
                  onChange={(e) => handleInputChange("name", e.target.value)}
                />
                {errors.name && (
                  <div className="invalid-feedback">{errors.name}</div>
                )}
              </div>

              {/* Email */}
              <div className="col-md-12 mb-3">
                <label htmlFor="email" className="form-label">
                  Email <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  id="email"
                  placeholder="Enter email address"
                  value={formData.email}
                  onChange={(e) => handleInputChange("email", e.target.value)}
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email}</div>
                )}
              </div>

              {/* ARESA Center with Search */}
              <div className="col-md-12 mb-3">
                <label htmlFor="unit_centre" className="form-label">
                  ARESA Center
                </label>
                <div className="position-relative">
                  <select
                    className={`form-control ${
                      errors.unit_centre_id ? "is-invalid" : ""
                    }`}
                    id="unit_centre"
                    value={formData.unit_centre_id}
                    onChange={(e) => {
                      if (e.target.value === "search") {
                        setShowCenterDropdown(true);
                        setCenterSearch("");
                        return;
                      }
                      handleInputChange("unit_centre_id", e.target.value);
                      setShowCenterDropdown(false);
                    }}
                    onFocus={() => setShowCenterDropdown(false)}
                  >
                    <option value="">Select ARESA Center</option>
                    <option value="search">🔍 Search Centers...</option>
                    {getAllCenter &&
                      getAllCenter.map((center) => (
                        <option
                          key={center.UNIT_CENTRE_ID}
                          value={center.UNIT_CENTRE_ID}
                        >
                          {center.ADDRESS}
                        </option>
                      ))}
                  </select>

                  {showCenterDropdown && (
                    <div
                      className="position-absolute w-100 bg-white border rounded shadow-sm mt-1"
                      style={{ zIndex: 1000 }}
                    >
                      <div className="p-2 border-bottom">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Type to search ARESA centers..."
                          value={centerSearch}
                          onChange={(e) => setCenterSearch(e.target.value)}
                          autoFocus
                        />
                      </div>
                      <div style={{ maxHeight: "200px", overflowY: "auto",zIndex:999 }}>
                        {filteredCenters.length > 0 ? (
                          filteredCenters.map((center) => (
                            <div
                              key={center.UNIT_CENTRE_ID}
                              className="p-2 border-bottom cursor-pointer"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                handleInputChange(
                                  "unit_centre_id",
                                  center.UNIT_CENTRE_ID
                                );
                                setShowCenterDropdown(false);
                                setCenterSearch("");
                              }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#f8f9fa")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "white")
                              }
                            >
                              {/* <small className="text-muted d-block">
                                ID: {center.UNIT_CENTRE_ID}
                              </small> */}
                              <div>{center.ADDRESS}</div>
                            </div>
                          ))
                        ) : (
                          <div className="p-2 text-muted text-center">
                            {centerSearch
                              ? "No centers found"
                              : "Type to search..."}
                          </div>
                        )}
                      </div>
                      <div className="p-2 border-top bg-light">
                        <button
                          type="button"
                          className="btn  w-100"
                          style={{ background: "gray", color: "white" }}
                          onClick={() => {
                            setShowCenterDropdown(false);
                            setCenterSearch("");
                          }}
                        >
                          Close Search
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Create/Update Password */}
              {!isEdit && (
                <div className="col-md-12 mb-3">
                  <label htmlFor="password" className="form-label">
                    {isEdit ? "Update Password" : "Create Password"}{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      className={`form-control ${
                        errors.password ? "is-invalid" : ""
                      }`}
                      // readOnly={!isEdit}
                      readOnly
                      id="password"
                      placeholder="Enter password"
                      value={formData.password}
                      onChange={(e) =>
                        handleInputChange("password", e.target.value)
                      }
                    />
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                    >
                      <i
                        className={`bi ${
                          showPassword ? "bi-eye-slash" : "bi-eye"
                        }`}
                      ></i>
                    </button>
                    {errors.password && (
                      <div className="invalid-feedback d-block">
                        {errors.password}
                      </div>
                    )}
                  </div>
                  <small className="form-text text-muted">
                  <span className="text-danger">**</span>Default password is 12345
                  </small>
                </div>
              )}
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn "
              onClick={handleClose}
              style={{ background: "gray", color: "white" }}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSubmit}
            className="modern-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  {isEdit ? "Updating Member..." : "Adding Member..."}
                </>
              ) : (
                <>
                  <i
                    className={`bi ${
                      isEdit ? "bi-check-circle" : "bi-check-circle"
                    } me-2`}
                  ></i>
                  {isEdit ? "Update Member" : "Add Member"}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMember;
